import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import Header from '../parts/Header';

interface PageProps {
  pageNb?: number;
  totalPages?: number;
  withoutHeader?: boolean;
}

const Page = ({ children, pageNb, totalPages, withoutHeader }: PageProps & PropsWithChildren) => (
  <div
    className={classNames(
      'page shadow--large',
      'flex flex-col w-full aspect-[21/29.7] not-last:mb-8 bg-page shadow-2xl',
      'print:mb-0 print:bg-white print:overflow-hidden',
    )}
  >
    {!withoutHeader && <Header />}

    <div className="grow py-10 not-print:pb-30 not-print:max-desktop:pt-5 not-print:max-desktop:pb-20">{children}</div>

    {pageNb && totalPages ? (
      <footer className={classNames('p-4 text-accent text-center')}>
        {pageNb}/{totalPages}
      </footer>
    ) : null}
  </div>
);

export default Page;
